import axios from 'axios';

const api = axios.create({
    baseURL: `/api/v1.0/`,

    headers: {
        Authorization: `Bearer ${localStorage.getItem('default_auth_token')}`
    }
})

export { api }

export default {
    data() {
        return {
            api
        };
    },

    computed: {
        bearerToken() {
            return this.$auth.token();
        }
    },

    mounted() {
        const token = `Bearer ${this.bearerToken}`,
              headers = this.api.defaults.headers;

        if (headers['Authorization'] !== token) {
            headers['Authorization'] = token
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/api.js